package com.siriusxm.pia.views.unifiedaggregator.backfill

import androidx.compose.runtime.*
import com.siriusxm.pia.components.*
import com.siriusxm.pia.views.unifiedaggregator.AggregatorService
import com.siriusxm.pia.views.unifiedaggregator.replay.replaysContent

/**
 * Tab container for the Backfill section that provides Backfills and Replays tabs.
 * The selected tab is controlled by the [tab] parameter which maps to URL-based navigation.
 * When the "Backfills" tab is selected, the "New Backfill Job" action is shown.
 * When the "Replays" tab is selected, the "New Replay" action is shown (the aggregator authorizes the start through AVP).
 */
@Composable
fun ServiceViewContext.backfillSection(aggregator: AggregatorService, tab: String?) {
    val selectedTab = tab ?: "recent"

    serviceContentView({
        title = "Content Backfill"
        if (selectedTab == "recent") {
            action("New Backfill Job", false) {
                aggregator.navigate("backfill/new")
            }
        } else if (selectedTab == "replays") {
            action("New Replay", false) {
                aggregator.navigate("backfill/new-replay")
            }
        }
        breadcrumbs {
            crumb("Aggregator", "aggregator") {
                crumb("Backfill", null)
            }
        }
    }) {
        tabView {
            tabNavigation(aggregator, "backfill", selectedTab)

            tab("Snapshots", "recent") {
                backfillsContent(aggregator)
            }

            tab("Event Replays", "replays") {
                replaysContent(aggregator)
            }
        }
    }
}
